import { useParams } from 'react-router-dom'
import { MODE } from '../../../data/queryFactories'
import AccountGuestForm from '../../../features/account-management/account-guest/AccountGuestForm'
import { useNav } from '../../../hooks/useNav'
import useGetGuestAccountById from '../../../features/account-management/account-guest/hooks/useGetGuestAccountById'
import { PATH } from '../../../data/router_path'
export default function EditGuestAccountPage() {
  const { uuid } = useParams()
  const navigate = useNav()
  const { data, isLoading, error } = useGetGuestAccountById(uuid)


  if (isLoading) {
    return 'Đang tải'
  }
  if (error || !data) {
    navigate(PATH.ACCOUNT.GUEST.DETAIL(uuid))
    return
  }

  return (
    <AccountGuestForm
      mode={MODE.EDIT}
      initForm={{
        uuid: data.uuid,
        id: data.id,
        name: data.name,
        course: data.course,
        groups: data.groups.map((item) => item.uuid),
        personalEmail: data.personalEmail,
        schoolEmail: data.schoolEmail,
        phoneNumber: data.phoneNumber,
        className: data.className,
        faculty: '',
        school: '',
      }}
      submitHandler={(formData) => {}}
      uuid={uuid}
    />
  )
}
